import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="w-full bg-white py-14 px-4" data-id="element-106">
      <div className="max-w-2xl mx-auto text-center" data-id="element-107">
        <h1 className="text-3xl md:text-5xl font-black text-black leading-tight mb-8" data-id="element-108">
          No es que no quieras ayudar a tu hijo…
        </h1>

        <a href="#compra" className="block max-w-xs mx-auto mb-8" data-id="element-109">
          <img src="https://cdn.magicpatterns.com/uploads/wKWLMw3KQnGVPp1oRAKSPb/imagen_principal_pagina.png" alt="Kit de Aprendizaje en Casa" className="w-full h-auto" data-id="element-110" />
        </a>

        <h2 className="text-2xl md:text-3xl font-black text-red-600 mb-8 leading-snug" data-id="element-111">
          es que nadie te enseñó cómo hacerlo sin frustrarte
        </h2>

        <p className="text-lg md:text-xl text-gray-700 mb-10 leading-relaxed" data-id="element-112">
          Acompañar las tareas escolares no debería terminar en enojo, tensión o
          culpa. Con este sistema vas a entender cómo aprende tu hijo y qué
          hacer en cada momento.
        </p>

        <CTAButton text="👉 QUIERO EMPEZAR AHORA" href="#compra" className="w-full" data-id="element-113" />

        <p className="mt-6 text-base font-bold text-gray-500 tracking-wide" data-id="element-114">
          ✔ Acceso inmediato &nbsp;&nbsp; ✔ Descarga digital &nbsp;&nbsp; ✔
          Aplicación desde hoy
        </p>
      </div>
    </section>;
}